import { Helmet } from "react-helmet"
import React from "react"
import { useLocation } from "@reach/router"
import { useSiteMetadata } from "hooks/use-sitemetadata"

export const SEOComponent = ({
  brand,
  canonical,
  description,
  lang = `de`,
  no_brand,
  no_canonical = false,
  open_graph_image,
  open_graph_type,
  schema_org_data,
  schema_org_faq,
  title,
  event_schema_org_data,
}) => {
  const site = useSiteMetadata()
  const seo = {
    title: title || site.title,
    description: description || site.description,
  }
  const { pathname } = useLocation()
  const stringified_schema_org_data = schema_org_data
    ? JSON.stringify(schema_org_data)
    : null
  const stringified_schema_org_faq = schema_org_faq
    ? JSON.stringify(schema_org_faq)
    : null

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={`${seo.title}${!no_brand ? ` | ${brand || site.title}` : ""}`}
    >
      {!!no_canonical ? null : (
        <link
          rel="canonical"
          href={`https://bi-medien.de${
            typeof canonical !== "undefined" ? canonical : pathname
          }`}
        />
      )}
      {!!schema_org_data && (
        <script type="application/ld+json">
          {stringified_schema_org_data}
        </script>
      )}
      {!!stringified_schema_org_faq && (
        <script type="application/ld+json">{stringified_schema_org_faq}</script>
      )}
      {!!event_schema_org_data ? (
        <script type="application/ld+json">{event_schema_org_data}</script>
      ) : null}
      <meta name="description" content={seo.description} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={`https://bi-medien.de${pathname}`} />
      {open_graph_type ? (
        <meta property="og:type" content={open_graph_type} />
      ) : (
        <meta property="og:type" content="website" />
      )}
      {open_graph_image?.url && (
        <meta property="og:image" content={open_graph_image.url} />
      )}
      {open_graph_image?.alt && (
        <meta property="og:image:alt" content={open_graph_image.alt} />
      )}
      {open_graph_image?.width && (
        <meta property="og:image:width" content={open_graph_image.width} />
      )}
      {open_graph_image?.height && (
        <meta property="og:image:height" content={open_graph_image.height} />
      )}
    </Helmet>
  )
}
